import { render } from "./StudentParametersBlock.vue?vue&type=template&id=2cc81792&scoped=true"
import script from "./StudentParametersBlock.vue?vue&type=script&lang=js"
export * from "./StudentParametersBlock.vue?vue&type=script&lang=js"

import "./StudentParametersBlock.vue?vue&type=style&index=0&id=2cc81792&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc81792"]])

export default __exports__